import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
    transform: translateX(-2px);
  }

  svg {
    font-size: 16px;
  }
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 24px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const SearchPanel = styled.div`
  width: ${props => props.$isCollapsed ? '60px' : '300px'};
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: width 0.3s ease;

  h6 {
    color: ${COLORS.PRIMARY};
    font-weight: 600;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MainSection = styled.div`
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: auto;
`;

export const SearchContainer = styled.div`
  position: relative;

  .MuiOutlinedInput-root {
    background-color: white;
    height: 40px;
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.PRIMARY};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.PRIMARY};
    }
  }

  .MuiInputBase-input {
    padding: 8px 14px;
  }

  svg {
    color: ${COLORS.SECONDARY};
  }
`;

export const CollapseButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
  }

  svg {
    font-size: 16px;
  }
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${COLORS.PRIMARY};
  color: white;

  svg {
    font-size: 14px;
  }
`;

export const SearchResults = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid ${COLORS.BACKGROUND};
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SearchResultItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${COLORS.BACKGROUND};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${COLORS.BACKGROUND_PRIMARY};
  }

  .MuiTypography-body2 {
    color: ${COLORS.PRIMARY};
    font-weight: 500;
  }

  .MuiTypography-caption {
    color: ${COLORS.SECONDARY};
  }
`;

export const SelectedProjects = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  min-height: 32px;
  width: 100%;

  .MuiChip-root {
    flex-grow: 1;
    max-width: calc(50% - 4px);
    justify-content: space-between;
  }
`;

export const SortButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  .MuiIconButton-root {
    background-color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    &:hover {
      background-color: ${COLORS.BACKGROUND};
    }

    &.MuiIconButton-colorPrimary {
      color: ${COLORS.PRIMARY};
      background-color: ${COLORS.BACKGROUND};
    }
  }
`; 